<template>
  <Button
    type="ghost"
    variant="black"
    class="!text-white active:!text-white active:!bg-slate-700 hover:!bg-slate-600"
    data-testid="viewer-transcription-cancel"
    @click.prevent="restoreAll"
    >Cancel</Button
  >
</template>

<script setup lang="ts">
import { Button } from '@/storybook';
import { TrackEvents, useViewerTrack } from '@/modules/viewer/composables/useViewerTrack';
import { useTranscriptionStore } from '@/modules/viewer/store/useTranscriptionStore';

const { trackItemOwner } = useViewerTrack();
const transcriptionStore = useTranscriptionStore();

const restoreAll = () => {
  trackItemOwner(TrackEvents.VIEWER_TRANSCRIPTION_CORRECTION_CANCEL);
  transcriptionStore.lineRestoreAll();
};
</script>
